import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class LoanDetailsSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        page: 1,
      },
      openDrawer: false,
    };

    this.isAdmin = this.props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
    // search fields
    this.pendingFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        name: "underwriterName",
        label: "Underwriter Name",
        type: "text",
        placeholder: "Underwriter Name",
      },
      {
        name: "loanAccountNumber",
        label: "Loan Account Number",
        type: "text",
        placeholder: "Loan Account Number",
      },
      {
        name: "sanctionedLoanAmount",
        label: "Sanctioned Amount",
        type: "number",
        placeholder: "Sanctioned Amount",
      },
      {
        name: "sanctionedLoanStartDate",
        label: "Loan Start Date",
        type: "date",
      },
      {
        name: "sanctionedLoanEndDate",
        label: "Loan End Date",
        type: "date",
      },
      {
        name: "sanctionedLoanIRR",
        label: "ROI",
        type: "number",
      },
    ];
    this.activeLoansFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        name: "mobileNumber",
        label: "Phone Number",
        type: "text",
        placeholder: "Phone Number",
      },
      {
        name: "pan",
        label: "PAN Number",
        type: "text",
        placeholder: "PAN Number",
      },
      {
        name: "loanAccountNumber",
        label: "Loan Account Number",
        type: "text",
        placeholder: "Loan Account Number",
      },
      {
        name: "startDate",
        label: "Loan Start Date",
        type: "date",
        placeholder: "Loan Start Date",
      },
      {
        name: "endDate",
        label: "Loan End Date",
        type: "date",
        placeholder: "Loan End Date",
      },
      {
        name: "status",
        label: "Loan Status",
        type: "select",
        options: _enum.ACTIVE_LOAN_SEARCH_OPTIONS,
        placeholder: "Status",
      },
    ];
    this.closedLoansFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        name: "mobileNumber",
        label: "Phone Number",
        type: "text",
        placeholder: "Phone Number",
      },
      {
        name: "pan",
        label: "PAN Number",
        type: "text",
        placeholder: "PAN Number",
      },
      {
        name: "loanAccountNumber",
        label: "Loan Account Number",
        type: "text",
        placeholder: "Loan Account Number",
      },
      {
        name: "startDate",
        label: "Loan Start Date",
        type: "date",
        placeholder: "Loan Start Date",
      },
      {
        name: "endDate",
        label: "Loan End Date",
        type: "date",
        placeholder: "Loan End Date",
      },
      {
        name: "status",
        label: "Loan Status",
        type: "select",
        options: _enum.ACTIVE_LOAN_SEARCH_OPTIONS,
        placeholder: "Status",
      },
      {
        name: "totalRepaymentAmtTillDate",
        label: "Total Paid Amount",
        type: "number",
        placeholder: "Total Paid Amount",
      },
      {
        name: "loanClosingDate",
        label: "Loan Closer Date",
        type: "date",
        placeholder: "Loan Closer Date",
      },
    ];
    this.settlementsLoansFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        name: "underWriterName",
        label: "Underwriter Name",
        type: "text",
        placeholder: "Underwriter Name",
      },
      {
        name: "phoneNo",
        label: "Phone Number",
        type: "text",
        placeholder: "Phone Number",
      },
      {
        name: "pan",
        label: "PAN Number",
        type: "text",
        placeholder: "PAN Number",
      },
      {
        name: "loanAccountNumber",
        label: "LAN No.",
        type: "text",
        placeholder: "LAN No.",
      },
      {
        name: "startDate",
        label: "Loan Start Date",
        type: "date",
        placeholder: "Loan Start Date",
      },
      {
        name: "endDate",
        label: "Loan End Date",
        type: "date",
        placeholder: "Loan End Date",
      },
      {
        name: "status",
        label: "Loan Status",
        type: "select",
        options: _enum.CLOSE_LOAN_ACCOUNT_STATUS,
        placeholder: "Status",
      },
      {
        name: "writeOffAmount",
        label: "Write-Off Amount",
        type: "number",
        placeholder: "Write-Off Amount",
      },
      {
        name: "settlementAmount",
        label: "Settlement Amount",
        type: "number",
        placeholder: "Settlement Amount",
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let {
      isAdmin,
      pendingFields,
      activeLoansFields,
      closedLoansFields,
      settlementsLoansFields,
    } = this;
    let { activeKey } = this.props;
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        {activeKey !== "pendingrestructure" && (
          <button
            type="button"
            className="btn filter_modal_btn"
            onClick={(...args) => this.toggleDrawer(...args)}
          >
            <i class="fa-solid fa-filter me-2"></i>
            <span>Filters</span>
          </button>
        )}
        <AppDynamicFilterModal
          key={activeKey}
          open={openDrawer}
          onClose={this.closeDrawer}
          {...(activeKey === "pending"
            ? {
                fields: pendingFields,
              }
            : activeKey === "active"
            ? {
                fields: activeLoansFields,
              }
            : activeKey === "closed"
            ? {
                fields: closedLoansFields,
              }
            : activeKey === "loansettlements"
            ? {
                fields: settlementsLoansFields,
              }
            : { fields: [] })}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(LoanDetailsSearch);
